namespace RioERP.Products {
    export interface ProductBillingItemsRow {
        Id?: number;
        ProductId?: number;
        BillingItemName?: string;
        GrossAmount?: number;
        EDiscountType?: Web.Enums.DiscountType;
        TaxCategoryId?: number;
        HsnMasterId?: number;
        IncludingTax?: boolean;
        InvoiceCompanyId?: number;
        SpecialGrossAmount?: number;
        StartDate?: string;
        EndDate?: string;
        IsActive?: boolean;
        ProductProductName?: string;
        ProductDescription?: string;
        ProductSkuCode?: string;
        ProductEProductType?: number;
        ProductERioplayVersion?: number;
        ProductRioplayProductCode?: string;
        ProductDownloadUrl1?: string;
        ProductDownloadUrl2?: string;
        ProductHasPenDrive?: boolean;
        ProductHasBooks?: boolean;
        ProductHasCourier?: boolean;
        ProductNote?: string;
        ProductWeight?: number;
        ProductHeight?: number;
        ProductWidth?: number;
        ProductLength?: number;
        ProductEPackingType?: number;
        ProductGrossAmount?: number;
        ProductEOpens?: number;
        ProductEWatchTime?: number;
        ProductEValidity?: number;
        ProductEValidityType?: number;
        ProductValidTill?: string;
        ProductTotalAllowedDuration?: number;
        ProductAllowSerialKeyGeneration?: boolean;
        ProductAllowedDevices?: string;
        ProductIsLive?: boolean;
        ProductProcesOrderOnPaid?: boolean;
        ProductEAccessStatus?: number;
        ProductInAppDownload?: boolean;
        ProductHasVod?: boolean;
        ProductTemplateSerialKeyId?: number;
        ProductIsActive?: boolean;
        ProductInsertUserId?: number;
        ProductInsertDate?: string;
        ProductUpdateUserId?: number;
        ProductUpdateDate?: string;
        ProductVendorId?: number;
        ProductSupportInfo?: string;
        ProductProductQueryInfo?: string;
        ProductEShippedby?: number;
        ProductActivateSerialKey?: boolean;
        ProductIsCombo?: boolean;
        ProductProductIds?: string;
        ProductWebsiteUrl?: string;
        ProductTeacherName?: string;
        TaxCategoryName?: string;
        TaxCategoryIsActive?: boolean;
        TaxCategoryInsertUserId?: number;
        TaxCategoryInsertDate?: string;
        TaxCategoryUpdateUserId?: number;
        TaxCategoryUpdateDate?: string;
        HsnMasterName?: string;
        HsnMasterHsnCode?: string;
        HsnMasterTaxCategoryId?: number;
        HsnMasterIsActive?: boolean;
        HsnMasterInsertUserId?: number;
        HsnMasterInsertDate?: string;
        HsnMasterUpdateUserId?: number;
        HsnMasterUpdateDate?: string;
        InvoiceCompanyName?: string;
        InvoiceCompanyAddress?: string;
        InvoiceCompanyGstIn?: string;
        InvoiceCompanyInvoiceCode?: string;
        InvoiceCompanyIsTaxApplicable?: boolean;
        InvoiceCompanyInvoiceChangeDate?: string;
        InvoiceCompanyIsDefault?: boolean;
        InvoiceCompanyFooterNote?: string;
        InvoiceCompanyLogo1?: string;
        InvoiceCompanyLogo2?: string;
        InvoiceCompanyStampImage?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ProductBillingItemsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'BillingItemName';
        export const localTextPrefix = 'Products.ProductBillingItems';
        export const lookupKey = 'Products.ProductBillingItems';

        export function getLookup(): Q.Lookup<ProductBillingItemsRow> {
            return Q.getLookup<ProductBillingItemsRow>('Products.ProductBillingItems');
        }
        export const deletePermission = 'Products:ProductsManagement:Modify';
        export const insertPermission = 'Products:ProductsManagement:Modify';
        export const readPermission = 'Products:ProductsManagement:View';
        export const updatePermission = 'Products:ProductsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            ProductId = "ProductId",
            BillingItemName = "BillingItemName",
            GrossAmount = "GrossAmount",
            EDiscountType = "EDiscountType",
            TaxCategoryId = "TaxCategoryId",
            HsnMasterId = "HsnMasterId",
            IncludingTax = "IncludingTax",
            InvoiceCompanyId = "InvoiceCompanyId",
            SpecialGrossAmount = "SpecialGrossAmount",
            StartDate = "StartDate",
            EndDate = "EndDate",
            IsActive = "IsActive",
            ProductProductName = "ProductProductName",
            ProductDescription = "ProductDescription",
            ProductSkuCode = "ProductSkuCode",
            ProductEProductType = "ProductEProductType",
            ProductERioplayVersion = "ProductERioplayVersion",
            ProductRioplayProductCode = "ProductRioplayProductCode",
            ProductDownloadUrl1 = "ProductDownloadUrl1",
            ProductDownloadUrl2 = "ProductDownloadUrl2",
            ProductHasPenDrive = "ProductHasPenDrive",
            ProductHasBooks = "ProductHasBooks",
            ProductHasCourier = "ProductHasCourier",
            ProductNote = "ProductNote",
            ProductWeight = "ProductWeight",
            ProductHeight = "ProductHeight",
            ProductWidth = "ProductWidth",
            ProductLength = "ProductLength",
            ProductEPackingType = "ProductEPackingType",
            ProductGrossAmount = "ProductGrossAmount",
            ProductEOpens = "ProductEOpens",
            ProductEWatchTime = "ProductEWatchTime",
            ProductEValidity = "ProductEValidity",
            ProductEValidityType = "ProductEValidityType",
            ProductValidTill = "ProductValidTill",
            ProductTotalAllowedDuration = "ProductTotalAllowedDuration",
            ProductAllowSerialKeyGeneration = "ProductAllowSerialKeyGeneration",
            ProductAllowedDevices = "ProductAllowedDevices",
            ProductIsLive = "ProductIsLive",
            ProductProcesOrderOnPaid = "ProductProcesOrderOnPaid",
            ProductEAccessStatus = "ProductEAccessStatus",
            ProductInAppDownload = "ProductInAppDownload",
            ProductHasVod = "ProductHasVod",
            ProductTemplateSerialKeyId = "ProductTemplateSerialKeyId",
            ProductIsActive = "ProductIsActive",
            ProductInsertUserId = "ProductInsertUserId",
            ProductInsertDate = "ProductInsertDate",
            ProductUpdateUserId = "ProductUpdateUserId",
            ProductUpdateDate = "ProductUpdateDate",
            ProductVendorId = "ProductVendorId",
            ProductSupportInfo = "ProductSupportInfo",
            ProductProductQueryInfo = "ProductProductQueryInfo",
            ProductEShippedby = "ProductEShippedby",
            ProductActivateSerialKey = "ProductActivateSerialKey",
            ProductIsCombo = "ProductIsCombo",
            ProductProductIds = "ProductProductIds",
            ProductWebsiteUrl = "ProductWebsiteUrl",
            ProductTeacherName = "ProductTeacherName",
            TaxCategoryName = "TaxCategoryName",
            TaxCategoryIsActive = "TaxCategoryIsActive",
            TaxCategoryInsertUserId = "TaxCategoryInsertUserId",
            TaxCategoryInsertDate = "TaxCategoryInsertDate",
            TaxCategoryUpdateUserId = "TaxCategoryUpdateUserId",
            TaxCategoryUpdateDate = "TaxCategoryUpdateDate",
            HsnMasterName = "HsnMasterName",
            HsnMasterHsnCode = "HsnMasterHsnCode",
            HsnMasterTaxCategoryId = "HsnMasterTaxCategoryId",
            HsnMasterIsActive = "HsnMasterIsActive",
            HsnMasterInsertUserId = "HsnMasterInsertUserId",
            HsnMasterInsertDate = "HsnMasterInsertDate",
            HsnMasterUpdateUserId = "HsnMasterUpdateUserId",
            HsnMasterUpdateDate = "HsnMasterUpdateDate",
            InvoiceCompanyName = "InvoiceCompanyName",
            InvoiceCompanyAddress = "InvoiceCompanyAddress",
            InvoiceCompanyGstIn = "InvoiceCompanyGstIn",
            InvoiceCompanyInvoiceCode = "InvoiceCompanyInvoiceCode",
            InvoiceCompanyIsTaxApplicable = "InvoiceCompanyIsTaxApplicable",
            InvoiceCompanyInvoiceChangeDate = "InvoiceCompanyInvoiceChangeDate",
            InvoiceCompanyIsDefault = "InvoiceCompanyIsDefault",
            InvoiceCompanyFooterNote = "InvoiceCompanyFooterNote",
            InvoiceCompanyLogo1 = "InvoiceCompanyLogo1",
            InvoiceCompanyLogo2 = "InvoiceCompanyLogo2",
            InvoiceCompanyStampImage = "InvoiceCompanyStampImage",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
